import {Basic} from '@packages/systems/core/plugins';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {em} from '@packages/systems/core/utils/WebflowCssSubset';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          marginRight: em(0.33),
        },
      },
    },
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  fields: {children: TListOfElement},
});

export default config;
